export const navBarTabs = () => {
  return [
    {
      label: 'Home',
      path: '/',
      slug: 'home',
      icon: 'nav-home-icon.svg',
      icon_select: 'nav-home-select.svg',
      visibilityKey: 'homeTab',
      isMobile: true,
    },
    {
      label: 'Search',
      path: '/search',
      slug: 'search',
      icon: 'search_icon.svg',
      icon_select: 'nav-search-select.svg',
      visibilityKey: 'searchTab',
      isMobile: true,
    },
    {
      label: 'My Loads',
      path: '/myloads',
      slug: 'myLoads',
      icon: 'My-Load.svg',
      icon_select: 'myload-select.svg',
      visibilityKey: 'myLoadTab',
      isMobile: true,
    },
    {
      label: 'NAT/NAL',
      path: '/natnal',
      slug: 'natNal',
      icon: 'nav-natnal.svg',
      icon_select: 'nav-nat-nal-active.svg',
      visibilityKey: 'NatNalTab',
      isMobile: false,
    },
    {
      label: 'Financial Info',
      path: '/financial-info',
      slug: 'financialInfo',
      icon: 'nav-financial.svg',
      icon_select: 'nav-financial-select.svg',
      visibilityKey: 'financialInfoTab',
      isMobile: false,
    },
    {
      label: 'Manage',
      path: '/manage',
      slug: 'manage',
      icon: 'nav-manage.svg',
      icon_select: 'nav-manage-select.svg',
      visibilityKey: 'manageTab',
      isMobile: true,
    },
    {
      label: 'Horizon',
      path: '/horizon',
      slug: 'horizon',
      icon: 'horizon.svg',
      icon_select: 'horizon-select.svg',
      visibilityKey: 'horizonTab',
      isMobile: false,
    },
    {
      label: 'More',
      path: '/more',
      slug: 'more',
      icon: 'more-icon.svg',
      icon_select: 'more_select.svg',
      visibilityKey: 'moreTab',
      isMobile: false,
      subCategory: [
        {
          label: 'Feedback',
          path: '/feedback',
          slug: 'feedback',
          icon: 'feedback.svg',
          icon_select: 'feedback_select.svg',
          visibilityKey: 'feedBackTab',
        },
        {
          label: 'Preferences',
          path: '/preferences',
          slug: 'preferences',
          icon: 'Preferences.svg',
          icon_select: 'Preferences_select.svg',
          visibilityKey: 'preferenceTab',
        },
        {
          label: 'Support',
          path: '/support',
          slug: 'support',
          icon: 'Support.svg',
          icon_select: 'Support_select.svg',
          visibilityKey: 'supportTab',
        },
      ],
    },
    {
      label: 'More',
      path: '/more-mobile',
      slug: 'more-mobile',
      icon: 'more-icon.svg',
      icon_select: 'more_select.svg',
      visibilityKey: 'moreTab',
      isMobile: true,
    },
  ];
};

export const isMyLoad = (module: any) => module && module?.slug === 'home';
export const isHome = (module: any) => module && module?.slug === 'myLoads';
export const showGlobalSearchMobile = (module: any, isMobile: boolean) =>
  isMobile && (isMyLoad(module) || isHome(module));
